export const URL_GET_DATI_ISA =
    "/StatisticheIsaController/jaxrs/statisticheIsa/dati"
export const URL_GET_DATI_NAZIONALI =
    "/StatisticheIsaController/jaxrs/statisticheIsa/datiNazionali"
export const URL_GET_DATI_NAZIONALI_MULTI_ANNO =
    "/StatisticheIsaController/jaxrs/statisticheIsa/datiNazionaliMultiAnno"
export const URL_GET_LISTA_ISA_MULTI_ANNO =
    "/StatisticheIsaController/jaxrs/statisticheIsa/listaIsaMA"
export const URL_GET_DATI_REGIONALI_MULTI_ANNO =
    "/StatisticheIsaController/jaxrs/statisticheIsa/datiRegionaliMultiAnno"
export const URL_GET_DATI_REGIONALI =
    "/StatisticheIsaController/jaxrs/statisticheIsa/datiRegionali"
export const URL_GET_MACROAREE_TERRITORIALI =
    "/StatisticheIsaController/jaxrs/statisticheIsa/macroaree"
export const URL_GET_EXCEL_DATI_NAZIONALI =
    "/StatisticheIsaController/jaxrs/statisticheIsa/excelDatiNazionali"
export const URL_GET_EXCEL_DATI_NAZIONALI_V2 =
    "/StatisticheIsaController/jaxrs/statisticheIsa/excelDatiNazionaliV2"
export const URL_GET_EXCEL_DATI_NAZIONALI_MA_V2 =
    "/StatisticheIsaController/jaxrs/statisticheIsa/excelDatiNazionaliMAV2"
export const URL_GET_EXCEL_DATI_REGIONALI =
    "/StatisticheIsaController/jaxrs/statisticheIsa/excelDatiRegionali"
export const URL_GET_EXCEL_DATI_REGIONALI_V2 =
    "/StatisticheIsaController/jaxrs/statisticheIsa/excelDatiRegionaliV2"
export const URL_GET_EXCEL_DATI_REGIONALI_MA_V2 =
    "/StatisticheIsaController/jaxrs/statisticheIsa/excelDatiRegionaliMAV2"
    "/StatisticheIsaController/jaxrs/statisticheIsa/getGrafico"
export const URL_GRAFICO_BARRE =
    "/StatisticheIsaController/jaxrs/statisticheIsa/datiGraficoBarre"
export const URL_GRAFICO_REGIONI =
    "/StatisticheIsaController/jaxrs/statisticheIsa/datiGraficoRegioni"
export const URL_GET_PDF_DATI_NAZIONALI =
    "/StatisticheIsaController/jaxrs/statisticheIsa/pdfDatiNazionali"
export const URL_GET_PDF_DATI_NAZIONALI_V2 =
    "/StatisticheIsaController/jaxrs/statisticheIsa/pdfDatiNazionaliV2"
export const URL_GET_PDF_DATI_NAZIONALI_MA_V2 =
    "/StatisticheIsaController/jaxrs/statisticheIsa/pdfDatiNazionaliMAV2"
export const URL_GET_PDF_DATI_REGIONALI =
    "/StatisticheIsaController/jaxrs/statisticheIsa/pdfDatiRegionali"
export const URL_GET_PDF_DATI_REGIONALI_V2 =
    "/StatisticheIsaController/jaxrs/statisticheIsa/pdfDatiRegionaliV2"
export const URL_GET_ELENCO_ANNI =
    "/StatisticheIsaController/jaxrs/statisticheIsa/elencoAnni"
export const URL_GET_PDF_DATI_REGIONALI_MA_V2 =
    "/StatisticheIsaController/jaxrs/statisticheIsa/pdfDatiRegionaliMAV2"

export const TIPOLOGIA_DATI_NAZIONALI_ISA = "Dati Nazionali Isa"
export const TIPOLOGIA_DATI_NAZIONALI_MACRO = "Dati Nazionali Macro"
export const TIPOLOGIA_DATI_REGIONALI_ISA = "Dati Regionali Isa"
export const TIPOLOGIA_DATI_REGIONALI_MACRO = "Dati Regionali Macro"

export const TITLE_CPB = "Concordato Preventivo Biennale"
export const TITLE_DATI_NAZIONALI = "DATI NAZIONALI"
export const TITLE_DATI_REGIONALI = "DATI REGIONALI"
export const TITLE_TUTTI_GLI_ISA = "TUTTI GLI ISA"
export const TITLE_TOTALE = "TOTALE"
export const TITLE_PERSONE_FISICE = "PERSONE FISICHE"
export const TITLE_SOCIETA_PERSONE = "SOCIETA' DI PERSONE"
export const TITLE_SOCIETA_CAPITALI = "SOCIETA' DI CAPITALI"
export const TITLE_ENTI_NON_COMMERCIALI = "ENTI NON COMMERCIALI"
export const TITLE_SOC_CAPITALI_ENTI_NON_COMMERCIALI =
    "SOCIETA' DI CAPITALI ED ENTI NON COMMERCIALI"
export const TITLE_REGIONE = "REGIONE"
export const TITLE_NUM_POSIZIONI = "NUM. POSIZIONI"
export const TITLE_NUM_ADDETTI = "NUM. ADDETTI"
export const TITLE_RICAVI_COMPENSI = "RICAVI/COMPENSI (media)"
export const TITLE_REDDITI = "REDDITI (media)"
export const TITLE_PUNTEGGIO_ISA = "PUNTEGGIO ISA (media)"
export const TITLE_PUNTEGGIO_ISA_NO_ANOMALIE =
    "PUNTEGGIO ISA SENZA ANOMALIE (media)"
export const TITLE_TOTALI = "TOTALI"
export const TITLE_RE = "Re"
export const TITLE_RG = "Rg"
export const TITLE_RF = "Rf"
export const TITLE_MOB = "MOB"
export const TITLE_DESCRIZIONE = "DESCRIZIONE"
export const TITLE_MACROAREE_TERRITORIALI = "MOB - MACROAREE TERRITORIALI"

export const TAB_TOTALI = "TOTALI"
export const TAB_PERSONE_FISICHE = "Persone Fisiche"
export const TAB_SOCIETA_PERSONE = "Società di Persone"
export const TAB_SOCIETA_CAPITALI = "Società di Capitali"
export const TAB_ENTI_NON_COMMERCIALI = "Enti non Commerciali"
export const TAB_SOC_CAPITALI_ENTI_COMMERCIALI =
    "Società di Capitali ed Enti non Commerciali"
export const TAB_GRAFICI = "Grafici"
export const TAB_MACROAREE_TERRITORIALI = "MOB - Macroaree Territoriali"

// dati nazionali;
export const DATI_NUMERO_POSIZIONI = "Numero Posizioni"
export const DATI_NUMERO_POSIZIONI_CPB = "Numero Posizioni"
export const DATI_REDDITO_CPB = "Reddito Proposto"
export const DATI_VAL_PROD_CPB = "Valore Produzione Proposto" 
export const DATI_NUMERO_ADDETTI = "Numero Addetti"
export const DATI_PUNTEGGIO_AFFID_TOT = "Punteggio ISA (media)"
export const DATI_REDDITO_MEDIO = "Reddito d’impresa/lavoro autonomo o perdita dichiarato (media)"
export const DATI_ULTERIORI_COMP_POS =
    "Ulteriori componenti positivi dichiarati per migliorare il punteggio ISA (media)"

export const DATI_RICAVI_COMPENSI = "Ricavi/Compensi (media)"
export const DATI_RICAVI_DICHIARATI = "Dichiarati*"
export const DATI_RICAVI_STIMATI = "Stimati"
export const DATI_RICAVI_ADDETTO_DICHIARATI = "Dichiarati per addetto*"
export const DATI_RICAVI_ADDETTO_STIMATI = "Stimati per addetto"

export const INFO_RICAVI_COMPENSI = "* I Ricavi/Compensi dichiarati sono comprensivi anche degli ulteriori componenti positivi dichiarati per migliorare il punteggio ISA";

export const DATI_VALORE_AGGIUNTO = "Valore Aggiunto (media)"
export const DATI_VALORE_AGGIUNTO_DICHIARATI = "Dichiarato"
export const DATI_VALORE_AGGIUNTO_STIMATI = "Stimato"
export const DATI_VALORE_AGGIUNTO_ADDETTO_DICHIARATI = "Dichiarato per addetto"
export const DATI_VALORE_AGGIUNTO_ADDETTO_STIMATI = "Stimato per addetto"

export const DATI_REDDITO = "Reddito (media)"
export const DATI_REDDITO_DICHIARATI = "Dichiarato*"
export const DATI_REDDITO_STIMATI = "Stimato"
export const DATI_REDDITO_ADDETTO_DICHIARATI = "Dichiarato per addetto*"
export const DATI_REDDITO_ADDETTO_STIMATI = "Stimato per addetto"
export const INFO_REDDITO = "* Per le imprese, il valore del Reddito ai fini ISA è calcolato come reddito d’impresa al netto degli ulteriori elementi contabili (valore dei beni distrutti o sottratti relativi a materie prime e merci, compensi corrisposti ai soci per l'attività di amministratore, utili spettanti agli associati in partecipazione con apporti di solo lavoro e maggiorazioni fiscali). Per i lavoratori autonomi, il valore del Reddito ai fini ISA è calcolato come reddito al netto delle maggiorazioni fiscali";


export const DATI_INDICATORI_ELEM_AFF = "Indicatori Elementari di Affidabilità (punteggi)"
export const DATI_INDICATORI_ELEM_AFF_RICAVI_COMPENSI =
    "Ricavi/Compensi per addetto"
export const DATI_INDICATORI_ELEM_AFF_AGGIUNTO_ADDETTO =
    "Valore Aggiunto per Addetto"
export const DATI_INDICATORI_ELEM_AFF_REDDITO_ADDETTO = "Reddito per Addetto"
export const DATI_INDICATORI_ELEM_AFF_DECUMULO =
    "Durata e decumulo delle scorte"
export const DATI_INDICATORI_ELEM_AFF_COMPLESSIVO = "Complessivo"

export const DATI_ANOMALIA = "Indicatori Elementari di Anomalia"
export const DATI_AFFIDABILITA = "Indicatori Elementari di Affidabilità"
export const DATI_ANOMALIA_GESTIONE_CAR = "Gestione caratteristica"
export const DATI_ANOMALIA_GESTIONE_CAR_FREQUENZA_TOT =
    "Frequenza (Punteggio 1 e 1-5)"
export const DATI_ANOMALIA_GESTIONE_CAR_FREQUENZA = "Frequenza (Punteggio 1-5)"
export const DATI_ANOMALIA_GESTIONE_CAR_MEDIA = "Media (Punteggio 1-5)"
export const DATI_ANOMALIA_GESTIONE_CAR_FREQUENZA_01 = "Frequenza (Punteggio 1)"

export const TITLE_FREQUENZA_1 = "Frequenza"
export const TITLE_FREQUENZA_2 = "(Punteggio 1 e 1-5)"
export const TITLE_FREQUENZA_3 = "(Punteggio 1-5)"
export const TITLE_FREQUENZA_4 = "Media"
export const TITLE_FREQUENZA_5 = "(Punteggio 1)"

export const DATI_ANOMALIA_GESTIONE_BENI_STRUMENTALI =
    "Gestione dei beni strumentali (Frequenza)"
export const DATI_ANOMALIA_REDDITIVITA = "Redditività "
export const DATI_ANOMALIA_GESTIONE_EXTRA = "Gestione extra-caratteristica"
export const DATI_ANOMALIA_ATTIVITA_NON_INERENTI =
    "Attività non inerenti (Frequenza)"
export const DATI_ANOMALIA_INDICATORI_SPECIFICI = "Indicatori specifici"
export const DATI_ANOMALIA_ALTRI_INDICATORI = "Altri Indicatori"

export const DATI_RICAVI_COMPENSI_DICH_TOT = "Ricavi/Compensi dichiarati"
export const DATI_RICAVI_COMPENSI_STIMATI_TOT = "Ricavi/Compensi stimati"
export const DATI_RICAVI_COMPENSI_ADD_DICH =
    "Ricavi/Compensi per addetto dichiarati"
export const DATI_RICAVI_COMPENSI_ADD_STIMATI =
    "Ricavi/Compensi per addetto stimati"
export const DATI_PUNTEGGIO_AFFID_RICAVI_ADD =
    "Punteggio di affidabilità Ricavi per addetto"
export const DATI_VAL_ADD_DICH_TOT = "Valore aggiunto dichiarato"
export const DATI_VAL_ADD_STIMATO_TOT = "Valore aggiunto stimato"
export const DATI_AGGIUNTO_ADD_DICH = "Valore aggiunto per addetto dichiarato"
export const DATI_AGGIUNTO_ADD_STIMATO = "Valore aggiunto per addetto stimato"
export const DATI_PUNTEGGIO_AFF_VAL_ADD_ADETTO =
    "Punteggio di affidabilità Valore aggiunto per addetto"
export const DATI_REDDITO_DICH_TOT = "Reddito dichiarato"
export const DATI_REDDITO_STIMATO_TOT = "Reddito stimato"
export const DATI_REDDITO_ADD_DICH = "Reddito per addetto dichiarato"
export const DATI_REDDITO_ADD_STIMATO = "Reddito per addetto stimato"
export const DATI_PUNTEGGIO_AFF_REDDITO_ADD =
    "Punteggio di affidabilità Reddito per addetto"
export const DATI_PUNTEGGIO_AFF_REDDITO_ADD_1 = "Punteggio di affidabilità"
export const DATI_PUNTEGGIO_AFF_REDDITO_ADD_2 = "Reddito per addetto"
export const DATI_DURATA_SCORTE_DICH = "Durata delle scorte dichiarata"
export const DATI_PUNTEGGIO_AFF_DURATA_SCORTE =
    "Punteggio di affidabilità Durata delle scorte"
export const DATI_DECUMULO_SCORTE_DECUMULO = "Decumulo delle scorte dichiarato"
export const DATI_PUNTEGGIO_AFF_DECUMULO_SCORTE =
    "Punteggio di affidabilità Decumulo delle scorte"
export const DATI_PUNTEG_AFFIDABILITA =
    "Punteggio di affidabilità Durata e decumulo delle scorte"
export const DATI_PUNTEG_INDIC_ELEM_AFF =
    "Punteggio Indicatori elementari di anomalia"
export const DATI_PUNTEG_ANOMALIE_BENI =
    'Punteggio anomalie relative alla "Gestione caratteristica" '
export const DATI_PUNTEG_BENI_STRUMENTALI =
    'Punteggio anomalie relative alla "Gestione dei beni strumentali" '
export const DATI_PUNTEG_ANOMALIE_REDD =
    'Punteggio anomalie relative alla "Redditività" '
export const DATI_PUNTEG_ANOMALIE_EXTRA =
    'Punteggio anomalie relative alla "Gestione extra-caratteristica" '
export const DATI_PUNTEG_ANOMALIE_NON_INERENTI =
    'Punteggio anomalie relative alle "Attività non inerenti" '
export const DATI_PUNTEG_ANOMALIE_INDICATORI =
    'Punteggio anomalie relative agli "Indicatori specifici" '

export const ELEMENTO_NON_DISPONIBILE = "-"

// MACROAREA;
export const MACRO_AGRICOLTURA = "Agricoltura"
export const MACRO_COMMERCIO = "Commercio"
export const MACRO_SERVIZI = "Servizi"
export const MACRO_MANIFATTURE = "Manifatture"
export const MACRO_PROFESSIONISTI = "Professionisti"

// LISTA MOB;
export const MOB1 = "MOB1"
export const MOB2 = "MOB2"
export const MOB3 = "MOB3"
export const MOB4 = "MOB4"
export const MOB5 = "MOB5"
export const MOB6 = "MOB6"
export const MOB7 = "MOB7"
export const MOB8 = "MOB8"
export const MOB9 = "MOB9"
export const MOB10 = "MOB10"
export const MOB11 = "MOB11"
export const MOB12 = "MOB12"
export const MOB13 = "MOB13"
export const MOB14 = "MOB14"
export const MOB15 = "MOB15"
export const MOB16 = "MOB16"
export const MOB17 = "MOB17"
export const MOB18 = "MOB18"

export const CARATTERE_RISERVATEZZA = "***"

// MACROAREE TERRITORIALI
export const MACROAREE_TERRITORIALI_CENTRO = "CENTRO"
export const MACROAREE_TERRITORIALI_ISOLE = "ISOLE"
export const MACROAREE_TERRITORIALI_NORD_EST = "NORD-EST"
export const MACROAREE_TERRITORIALI_NORD_OVEST = "NORD-OVEST"
export const MACROAREE_TERRITORIALI_SUD = "SUD"

export const HEADER_CONFIG = {
    "X-Content-Type-Options": "nosniff",
    "X-XSS-Protection": "1; mode=block",
    "X-Frame-Options": "deny",
    "Strict-Transport-Security": "max-age=16070400; includeSubDomains",
    "Access-Control-Allow-Methods": "GET",
    "Content-Security-Policy": "script-src 'self'"
}
